import React from "react";
import LinkedInShare from "./../../../../../assets/linkedin-share.png"

const LinkedInAppPreview = () => {
    return (
        <div className="linkedin-preview">
            <img src={LinkedInShare} alt="LinkedIn Auth Preview" />
        </div>
    );
};

export default LinkedInAppPreview;
